import React from 'react'
import WizardStepBase from '../base'
import { Link, withRouter } from 'react-router-dom'

import OptionSelectBox from 'app/components/option_select_box'
import constants from '../../../constants'

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import _ from 'lodash';

import * as orderActions from '../../../actions/order_actions';

class WizardStepThree extends WizardStepBase{
  constructor(props) {
    super(props);
    this.stepNum = 3;
  }

  getSelectedGroupItem(group) {
    return this.props.order_state.groups[group];
  }

  sizeFilter(collection, sizeAttr) {
    let attr = sizeAttr || 'inside_panel_size';
    return collection.filter(item => {
      let
        selectedSize = this.props.order_state.groups.size;
        let height = 0, width = 0;

      if (selectedSize.items) {
        if (selectedSize.selected == 'SIZE') {
          let value = selectedSize.items[0].value.split('*');
          height = value[1] * 1;
          width = value[0] * 1;
        } else if (selectedSize.selected == 'CUSTOM_SIZE') {
          height = selectedSize.inputValues[0];
          width = selectedSize.inputValues[1];
        }
      }
      return (!item[attr] || this.isSizeAvailable(item[attr], height, width));
    });
  }

  isSizeAvailable(size, height, width) {
    return size.min_height <= height && size.max_height > height && size.min_width <= width && size.max_width > width;
  }

  render() {
    let
      parts = this.props.parts_state,
      openCurrent = null,
      chain = this.props.order_state.actionsChain;

    if (chain && chain.length) {
      openCurrent = chain[0].split('-')[1];
    }

    return (
      <div>
        <h1>Внешний вид</h1>
        <div className='wizard-screen screen-3'>
          <div className='wizard-screen-row small-margin-'>
            <div className='wizard-screen-cell cell-1-2'>
              {(() => !parts.OutsideColor.length ? (<div />) : (
                <OptionSelectBox
                  showNow={ openCurrent == 'OutsideColor' }
                  removeFromActionsChain={this.props.order_actions.removeFromActionsChain}
                  title="Цвет внешней отделки"
                  buttonTitle="Выбрать цвет внешней отделки"
                  buttonShortTitle="Выбрать цвет"
                  group='OutsideColor'
                  onItemSelected={this.props.order_actions.constructionItemSelected}
                  showHint={this.props.order_actions.showHint}
                  hideHint={this.props.order_actions.hideHint}
                  currentGroupItem={this.getSelectedGroupItem('OutsideColor')}
                  collection={ parts.OutsideColor }
                  typeFilter={ parts.OutsideColorType }
                  constructionOptions={_.get(this.props.constructions_state.selected_type, 'construction_type_options', {})}
                  needRequire={this.isFactoryStandartSelected}
                />
              ))()}
            </div>
            <div className='wizard-screen-cell cell-1-2'>
              {(() => !parts.ForgedFinish.length ? (<div />) : (
                <OptionSelectBox
                  removeFromActionsChain={this.props.order_actions.removeFromActionsChain}
                  showNow={ openCurrent == 'ForgedFinish' }
                  title="Кованная отделка"
                  buttonTitle="Добавить кованую отделку"
                  buttonShortTitle="Выбрать ковку"
                  group='ForgedFinish'
                  optionsListClass="large-images"
                  onItemSelected={this.props.order_actions.constructionItemSelected}
                  showHint={this.props.order_actions.showHint}
                  hideHint={this.props.order_actions.hideHint}
                  currentGroupItem={this.getSelectedGroupItem('ForgedFinish')}
                  collection={ this.sizeFilter(parts.ForgedFinish, 'forged_finish_size') }
                  constructionOptions={_.get(this.props.constructions_state.selected_type, 'construction_type_options', {})}
                  needRequire={this.isFactoryStandartSelected}
                />
              ))()}
            </div>
          </div>
          <div className='wizard-screen-row'>
            <div className='wizard-screen-cell cell-2-2'>
              <div className={`wizard-block-form selectable-block united-two-cols ${this.getSelectedGroupItem('InsidePanel') || this.getSelectedGroupItem('InsideColor') ? 'selected' : ''}`}>
                <div className='wizard-united-col'>
                  {(() => !parts.InsidePanel.length ? (<div />) : (
                    <OptionSelectBox
                      removeFromActionsChain={this.props.order_actions.removeFromActionsChain}
                      showNow={ openCurrent == 'InsidePanel' }
                      title="Внутренняя отделка"
                      buttonTitle="Добавить панель"
                      buttonShortTitle="Выбрать панель"
                      group='InsidePanel'
                      optionsListClass="large-images"
                      withoutSelectable={true}
                      onItemSelected={this.props.order_actions.constructionItemSelected}
                      showHint={this.props.order_actions.showHint}
                      hideHint={this.props.order_actions.hideHint}
                      currentGroupItem={this.getSelectedGroupItem('InsidePanel')}
                      collection={ this.sizeFilter(parts.InsidePanel) }
                      typeFilter={ parts.InsidePanelType }
                      constructionOptions={_.get(this.props.constructions_state.selected_type, 'construction_type_options', {})}
                      needRequire={this.isFactoryStandartSelected}
                    />
                  ))()}
                </div>
                <div className='wizard-united-col'>
                  {(() => !parts.InsideColor.length ? (<div />) : (
                    <OptionSelectBox
                      removeFromActionsChain={this.props.order_actions.removeFromActionsChain}
                      showNow={ openCurrent == 'InsideColor' }
                      title="Цвет внутренней отделки"
                      buttonTitle="Выбрать цвет"
                      buttonShortTitle="Выбрать цвет"
                      zeroCountMessage="Сперва выберите панель."
                      group='InsideColor'
                      withoutSelectable={true}
                      onItemSelected={this.props.order_actions.constructionItemSelected}
                      showHint={this.props.order_actions.showHint}
                      hideHint={this.props.order_actions.hideHint}
                      currentGroupItem={this.getSelectedGroupItem('InsideColor')}
                      collection={ _.filter(parts.InsideColor, (item) => item.part_parent_id == _.get(this.getSelectedGroupItem('InsidePanel'), 'id')) }
                      typeFilter={ parts.InsideColorType }
                      forcePopup={ this.props.order_state.needForcePopupFor == 'InsideColor' }
                      setForcePopupFor={ this.props.order_actions.setForcePopupFor }
                      constructionOptions={_.get(this.props.constructions_state.selected_type, 'construction_type_options', {})}
                      needRequire={this.isFactoryStandartSelected}
                    />
                  ))()}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="mobile-show">
          <Link onClick={this.stepChange} className='back-link' to={constants.ROUTES.STEP2}>Вернуться к выбору размеров</Link>
        </div>
        <Link onClick={this.stepChange} className='button button-red button-large wizard-next-action-button' to={constants.ROUTES.STEP4}>
          <span>перейти к замкам и фурнитуре</span>
        </Link>
        <div className="mobile-hidden">
          <Link className='back-link' to={constants.ROUTES.STEP2}>Вернуться к выбору размеров</Link>
        </div>
        {this.renderConfirm()}
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    parts_state: state.partsState,
    constructions_state: state.constructionsState,
    order_state: state.orderState,
    app: state.applicationState
  }
};

const mapDispatch = (dispatch) => {
  return {
    order_actions: bindActionCreators(orderActions, dispatch)
  };
};

export default withRouter(connect(mapStateToProps, mapDispatch, null, {pure: false})(WizardStepThree));



// WEBPACK FOOTER //
// ./app/javascript/app/pages/wizard_steps/step_3/index.jsx